import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo3_Bernardo } from '../../../../../utils/ES/Modals/directors';

const ModalVideoBernardo3 = () => {
  return (
    <>
      <ModalVideo
        id="bernardo-video-3"
        dataText={TextVideo3_Bernardo}
        videoSrc="https://player.vimeo.com/video/698689487?h=9fa34c35f5&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_BERNARDO_3"
      />
    </>
  );
};

export default ModalVideoBernardo3;
